export { default as AdditionalCover } from './AdditionalCover';
export { default as MedicalDeclaration } from './MedicalDeclaration';
export { default as Payment } from './Payment';
export { default as PaymentB } from './PaymentB';
export { default as QuoteSummary } from './QuoteSummary';
export { default as SchemeChoice } from './SchemeChoice';
export { default as SchemeChoiceB } from './SchemeChoiceB';
export { default as TripDetails } from './TripDetails';
export { default as Declaration } from './Declaration';
export { default as DeclarationB } from './DeclarationB';
export { default as PersonalDetails } from './PersonalDetails';
export { default as PersonalDetailsB } from './PersonalDetailsB';
export { default as Complete } from './Complete';
export { default as TripDetailsJourneyB } from './TripDetailsJourneyB';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/index.ts